



























import _ from 'lodash';

import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';

import Auth from "@aws-amplify/auth";
import ConfimModal from "@/components/modals/ConfirmModal.vue";

@Component({
	components: {ConfimModal}
})
export default class Support extends Vue {
	@Prop({ default: false }) public showsidebar: boolean;

	@Getter("app/hasBlockingRequests") public hasBlockingRequests: boolean;

	public mounted() {
	}

	public deleteaccount() {
    this.hide();
		this.signOut();

  }

	public showDeleteDialog() {
    const modal = (this.$refs.deleteConfirmModal as any).$el;
    ($(modal) as any).modal("show");
  }
  public hide() {
    let modal: any = (this.$refs.deleteConfirmModal as any).$el;
    ($(modal) as any).modal("hide");
  }

	public async signOut() {
    try {
      await Auth.signOut();
			this.$router.push({ name: "sign-in" });
    } catch (err) {
      this.$onecentral.displayError(err);
    }
  }
}
